import AlertModal from '@/components/ux/AlertModal/AlertModal';
import { capturePosthogEvent } from '@/helpers';
import { useCampaignBuilderStore, useCampaignsStore, useMaximizeStore } from '@/stores';
import React from 'react';
import { create } from 'zustand';

type CampaignFormArchiveStore = {
	open: boolean;
	campaignID: string | undefined;
	setOpen: (campaignID: string, type: 'archive' | 'delete') => void;
	close: () => void;
	type: 'archive' | 'delete' | undefined;
};

export const useCampaignFormArchiveStore = create<CampaignFormArchiveStore>()((set) => ({
	open: false,
	campaignID: undefined,
	type: undefined,
	setOpen: (campaignID: string, type: 'archive' | 'delete') => set({ open: true, campaignID, type }),
	close: () => set({ open: false, campaignID: undefined, type: 'archive' }),
}));

export default function CampaignArchiveModals() {
	const { isMaximized, unmaximize } = useMaximizeStore();
	const { setArchivedStatus, deleteCampaign } = useCampaignsStore();
	const { open, campaignID, type, close } = useCampaignFormArchiveStore();
	const { campaign, ogCampaign, setCampaign, setOgCampaign } = useCampaignBuilderStore();

	const confirmArchive = async () => {
		if (!campaignID) return;
		await setArchivedStatus(campaignID, !campaign?.archived);
		if (campaign?.id === campaignID) {
			setCampaign({ ...campaign, archived: !campaign?.archived });
			setOgCampaign({ ...ogCampaign, archived: !campaign?.archived });
		}
		capturePosthogEvent('Campaign - Archive Campaign - Confirm');
	};

	const confirmDelete = async () => {
		if (!campaignID) return;
		await deleteCampaign(campaignID);
		if (campaign?.id === campaignID) {
			setCampaign(undefined);
			setOgCampaign(undefined);
		}
		if (isMaximized) {
			unmaximize();
		}
		capturePosthogEvent('Campaign - Delete Campaign - Confirm');
	};

	const closeModal = () => {
		close();
	};

	return (
		<>
			<AlertModal
				open={open && type === 'archive'}
				onClose={closeModal}
				onConfirm={confirmArchive}
				title={campaign?.archived ? 'Unarchive Campaign' : 'Archive Campaign'}
				description={campaign?.archived ? 'Are you sure you want to unarchive this campaign?' : 'Are you sure you want to archive this campaign?'}
			/>

			<AlertModal
				open={open && type === 'delete'}
				onClose={closeModal}
				onConfirm={confirmDelete}
				title="Permanently Delete Form"
				description="Are you sure you want to delete this form? This action cannot be undone."
			/>
		</>
	);
}
